module.exports = __webpack_public_path__ + "static/img/jyjj.c318275.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/jyjj.jpg
// module id = jS0W
// module chunks = 0